import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
    id: string;
    email: string;
    username: string;
    first_name: string;
    last_name: string;
    bio?: string | null;
    location?: string | null;
    date_of_birth?: string | null;
    gender?: string | null;
    is_verified: boolean;
    is_active: boolean;
    subscription_tier: string;
}

interface AuthState {
    user: User | null;
    token: string | null;
    refreshToken: string | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: AuthState = {
    user: null,
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken'),
    isLoading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        loginSuccess: (state, action: PayloadAction<{ user: User; token: string; refreshToken?: string }>) => {
            state.isLoading = false;
            state.user = action.payload.user;
            state.token = action.payload.token;
            if (action.payload.refreshToken) {
                state.refreshToken = action.payload.refreshToken;
                localStorage.setItem('refreshToken', action.payload.refreshToken);
            }
            localStorage.setItem('token', action.payload.token);
        },
        loginFailure: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
        },
        clearError: (state) => {
            state.error = null;
        },
        updateToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
            localStorage.setItem('token', action.payload);
        },
        restoreSessionStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        restoreSessionSuccess: (state, action: PayloadAction<{ user: User }>) => {
            state.isLoading = false;
            state.user = action.payload.user;
        },
        restoreSessionFailure: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            state.error = action.payload;
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
        },
    },
});

export const {
    loginStart,
    loginSuccess,
    loginFailure,
    logout,
    clearError,
    updateToken,
    restoreSessionStart,
    restoreSessionSuccess,
    restoreSessionFailure,
} = authSlice.actions;
export default authSlice.reducer;
